import React from 'react'

const Statement = () => {
  return (
    <div className="npay-statement">
      <h4>Statement of The Problem</h4>
      <p>
        The Nigerian bills payments system is rigid and vastly manual, there has been a pressing need to digitalize and simply the payment process for citizens. <br />
        While conducting research as regards the needs of people on what they need on the N-PAY app the following were identified:
      </p>
      <ol>
        <li>
          <p>Citizens want to have a detailed history of their tax/bill payments on their devices.</p>
        </li>
        <li>
          <p>Receipt of payments should be downloadable and shareable from the app.</p>
        </li>
        <li>
          <p>Another challenge is the lack of a platform to inform users about the latest govenment decision which can influence bill payments.</p>
        </li>
        <li>
          <p>Also, users especially private workers need a form of reminder to inform them about due owings and amounts.</p>
        </li>
      </ol>
    </div>
  )
}

export default Statement